export default __webpack_public_path__ + "static/media/BearFamily_08.ecb8d4bb.png";